import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {CancelarPropostaModel} from "../../../../../aplicacao/models/cancelar-proposta.model";
import {NgxSpinnerService} from "ngx-spinner";
import {DeviceDetectorService} from "../../../../../core/services/device-detector.service";
import {TipoCancelamentoEnum} from "../../../../../aplicacao/enum/tipo-cancelamentos.enum";

@Component({
  selector: 'app-cancelar-proposta',
  templateUrl: './cancelar-proposta.component.html',
  styleUrls: ['./cancelar-proposta.component.scss']
})
export class CancelarPropostaComponent implements OnInit{
  listaMotivos = TipoCancelamentoEnum.getTypes();
  model = new CancelarPropostaModel();
  validarFormulario = true;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public dataBottom: any,
    @Optional() public dialogRef: MatDialogRef<CancelarPropostaComponent>,
    @Optional() private bottomSheetRef: MatBottomSheetRef<CancelarPropostaComponent>,
    private spinnerService: NgxSpinnerService,
    private deviceDetectorService: DeviceDetectorService,
  ) { }
  fechar(): void {
    if (!this.deviceDetectorService.isMobile()) {
      this.dialogRef.close(false);
    } else {
      this.bottomSheetRef.dismiss(false);
    }
  }

  ngOnInit() {
   if (this.data && this.data.listaMotivos) {
     this.listaMotivos = this.data.listaMotivos;
   }
   if (this.dataBottom && this.dataBottom.listaMotivos) {
     this.listaMotivos = this.dataBottom.listaMotivos;
   }
   if(this.deviceDetectorService.isMobile()) {
     this.model.asForm.controls.propostaId.setValue(this.dataBottom.propostaId);
   } else {
     this.model.asForm.controls.propostaId.setValue(this.data.propostaId);
   }
  }
  enviar(): void {
    if(this.model.form.valid) {
      this.validarFormulario = true;
      this.model.form.value.observacao ? this.model.form.value.observacao : delete this.model.form.value.observacao
      if (!this.deviceDetectorService.isMobile()) {
        this.dialogRef.close(this.model.form.value);
      } else {
        this.bottomSheetRef.dismiss(this.model.form.value);
      }
    } else {
      this.validarFormulario = false
    }
  }
}
